























































import { computed, defineComponent } from '@vue/composition-api'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import AButton from '@/components/AButton'
import AIcon from '@/components/AIcon'

export default defineComponent({
  name: 'APagination',

  components: { AButton, AIcon },

  props: {
    value: {
      type: Number,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
    totalVisible: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['input'],

  setup(props, ctx) {
    const pages = computed(() => {
      const p = []
      for (let i = 1; i <= props.length; i++) {
        p.push(i)
      }
      return p
    })

    const threshold = computed(() => {
      return Math.floor(props.totalVisible / 2)
    })

    const currentIndex = computed(() => {
      return pages.value.indexOf(props.value)
    })

    const visiblePages = computed(() => {
      if (!props.totalVisible) {
        return pages.value
      }

      let startIndex = currentIndex.value - threshold.value
      let endIndex = startIndex + props.totalVisible

      if (props.value <= props.totalVisible) {
        startIndex = 0
        endIndex = props.totalVisible
      } else if (props.totalVisible > props.length - props.value) {
        endIndex = props.length
        startIndex = endIndex - props.totalVisible
      }

      return pages.value.slice(startIndex, endIndex)
    })

    const showFirstPageBtn = computed(() => {
      return visiblePages.value[0] > threshold.value
    })

    const showLastPageBtn = computed(() => {
      return (
        props.length - threshold.value + 1 >
        visiblePages.value[visiblePages.value.length - 1]
      )
    })

    const isFirstPage = computed(() => {
      return props.value === 1
    })

    const isLastPage = computed(() => {
      return props.value === props.length
    })

    function updatePage(page: number) {
      ctx.emit('input', page)
    }

    return {
      mdiChevronLeft,
      mdiChevronRight,
      pages,
      threshold,
      showFirstPageBtn,
      showLastPageBtn,
      visiblePages,
      isFirstPage,
      isLastPage,
      updatePage,
    }
  },
})
